import { inject, Injectable } from '@angular/core';
import { SsoService } from '@devinforius/i-sso';
import * as signalR from '@microsoft/signalr';
import { LogLevel } from '@microsoft/signalr';
import { Subject } from 'rxjs';
import { NotifyUserSignalrPayload } from 'src/app/shared/models/signalr_payloads';

@Injectable({
  providedIn: 'root',
})
export class SignalrService {
  private readonly ssoService: SsoService = inject(SsoService);

  public data: any[];
  private hubConnection: signalR.HubConnection;

  private notifyUserSignalrSource = new Subject();
  notifyUser = this.notifyUserSignalrSource.asObservable();

  public register = () => {
    const config = JSON.parse(sessionStorage.getItem('globalConfig'));
    const signalrHubUrl = config.apiGatewayBaseUrl + '/SignalR/NotificationsHub';

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(signalrHubUrl, { accessTokenFactory: () => this.ssoService.accessToken() })
      .configureLogging(LogLevel.Information)
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: (retryContext: signalR.RetryContext): number =>
          retryContext.elapsedMilliseconds < 2000 ? 2000 : 5000,
      })
      .build();
    this.InitHubEvents();
  };

  public startConnection = (succesCallback?: () => unknown, errorCallback?: () => unknown) => {
    this.hubConnection
      .start()
      .then(() => {
        if (succesCallback) {
          succesCallback();
        }
      })
      .catch(() => {
        if (errorCallback) {
          errorCallback();
        }
      });
  };

  private InitHubEvents() {
    this.hubConnection.onreconnected(() => {});
    this.hubConnection.onclose(() => {
      // TODO: alert user  if needed after signalr deconnexion
    });

    this.hubConnection.on('notifyUser', (payload: NotifyUserSignalrPayload) => {
      this.notifyUserSignalrSource.next(payload);
    });
  }

  public stop() {
    this.hubConnection.stop();
  }
}
